import React from "react"
import { useTranslations } from "next-intl"

const withTranslations = (Component, path = undefined) => {
  const WithTranslationsWrapper = (props) => {
    const translate = useTranslations(path)
  
    return <Component {...props} translate={translate} />
  }

  WithTranslationsWrapper.getInitialProps = Component.getInitialProps

  return WithTranslationsWrapper
}

export default withTranslations

